import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Ids from '../components/overview/Ids';
import { fetchIds } from '../actions/ids';
import { fetchCountryWorkProfile } from '../actions/countryWorkProfile';
import IdProps from '../proptypes/id';

export class OverviewIds extends Component {
  static propTypes = {
    actionFetchIds: PropTypes.func.isRequired,
    actionFetchCountryWorkProfile: PropTypes.func.isRequired,
    active: PropTypes.arrayOf(
      PropTypes.shape({
        ...IdProps,
      }),
    ),
    expired: PropTypes.arrayOf(
      PropTypes.shape({
        ...IdProps,
      }),
    ),
    isFetching: PropTypes.bool.isRequired,
    isCountryWorkProfileFetching: PropTypes.bool.isRequired,
    showCredentials: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    active: [],
    expired: [],
  };

  componentDidMount() {
    const { actionFetchIds, isFetching } = this.props;
    if (!isFetching) {
      actionFetchIds();
    }
    this.maybeFetchCountryWorkProfile();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.showCredentials !== this.props.showCredentials) {
      this.maybeFetchCountryWorkProfile();
    }
  }

  maybeFetchCountryWorkProfile = () => {
    const {
      actionFetchCountryWorkProfile,
      isCountryWorkProfileFetching,
      showCredentials,
    } = this.props;
    if (showCredentials && !isCountryWorkProfileFetching) {
      actionFetchCountryWorkProfile();
    }
  };

  render() {
    const { active, expired } = this.props;
    return <Ids active={active} expired={expired} />;
  }
}

export const mapStateToProps = (state) => ({
  ...state.ids,
  isCountryWorkProfileFetching: state.countryWorkProfile.isFetching,
  showCredentials:
    state.featureFlags.countryWorkProfile && state.featureFlags.inlineEmailEdit,
});

const mapDispatchToProps = {
  actionFetchIds: fetchIds,
  actionFetchCountryWorkProfile: fetchCountryWorkProfile,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OverviewIds),
);
